import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { DistributionArea } from "../../../system/systemEdit/SystemEdit.types.ts";

export interface SystemTypeFieldProps {
    distributionArea: DistributionArea | undefined;
    onChange: (distributionArea: DistributionArea) => void;
    readOnly?: boolean;
    disabled: boolean;
    errorText?: string;
}

function SystemTypeField(props: SystemTypeFieldProps) {
    const { translateString } = useTranslation();

    const distributionAreaOptions = [
        { id: DistributionArea.GlobalSystem.toString(), name: translateString("globalSystem") },
        { id: DistributionArea.LocalSystem.toString(), name: translateString("localSystem") },
        { id: DistributionArea.PhysicalArchive.toString(), name: translateString("physicalArchive") },
    ];

    return (
        <DotLegalSelect
            label={translateString("distributionArea")}
            placeholder={translateString("distributionArea")}
            selectedItem={props.distributionArea !== undefined ? props.distributionArea.toString() : ""}
            options={distributionAreaOptions}
            disabled={props.disabled}
            onChange={
                props.readOnly
                    ? () => {}
                    : (value) => {
                          if (value) props.onChange(Number(value) as DistributionArea);
                      }
            }
            disableClearable
            toolTipText={translateString("systemTypeTooltip")}
            noOptionsLabel={translateString("noOptions")}
            errorText={props.errorText}
        />
    );
}

export default SystemTypeField;
